module.exports = __webpack_public_path__ + "static/media/leyre_harinadetrigo(1).82896d20.png";